import { render, staticRenderFns } from "./materialPage.vue?vue&type=template&id=2f543118&scoped=true"
import script from "./materialPage.vue?vue&type=script&lang=js"
export * from "./materialPage.vue?vue&type=script&lang=js"
import style0 from "./materialPage.vue?vue&type=style&index=0&id=2f543118&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f543118",
  null
  
)

export default component.exports